import React from 'react';
import mainAPI from '../api/MainAPI';
import models from '../model/models';
import BoxScannedPopup from '../components/popups/boxScannedPopup/BoxScannedPopup';
import toasts from 'utils/toasts.js';
import getLocation from '../utils/getLocation';
import boxScannedPopupModel from '../components/popups/boxScannedPopup/BoxScannedPopup.model';
import scanViewController from './scanViewController';
import offlineInventoryCheckController from './offlineInventoryCheckController';
import { barcodeAndOfflineLookup } from '../utils/barcodeLookup';
import {openEmptyBoxScannedPopup} from "./resealController";
import AppReviewPopup from "../components/popups/appReviewPopup/AppReviewPopup";
import BoxCheckScanProgressCard from "../components/pages/scanner/boxCheckScanProgressCard/BoxCheckScanProgressCard";
import uniq from 'lodash.uniq';
import {PopupAnimationMs} from "../utils/animationConstants";
import throttle from 'lodash.throttle';
let InventoryCheckController = function () {
	this.myRefs = {}
	this.start = () => {
		this.clear();
		scanViewController.showScanner('Inventory Check', 'Scan a box or a drug in the box', this._handleScan, null, true, null,
			{hideRootDelayMs:PopupAnimationMs}
		);
	};

	this.handleDuplicateScan = (text) => {
	   if(!this.lastScannedCode)return;
		 if((Date.now() - this.lastScannedCode.ts) < 1500)return;
		 if(!this.drugs.find(d=>(d.barcode_id === (text + '')))) return;
		 this.lastScannedCode = {text, ts:Date.now()};
		 this.showDuplicateScanToast(text);
	}

	this.showDuplicateScanToast = throttle((text) => {
		toasts.show(`already scanned ${text}`, 1000);
	},1000,{leading:true, trailing:false});

	this.clear = () => {
		this.lastScanManual = null;
		this.drugs = [];
		boxScannedPopupModel.clear();
	};

	this.foundBox = (box, drug) => {
		getLocation();
		scanViewController.hideMainViewDuringAnimation();
    openEmptyBoxScannedPopup(box, drug, false, this.completed)
		scanViewController.hideScanner(PopupAnimationMs * 2, 'behind');
		return { value: box, lastDrugScanned: drug }; // remove last scanned drug
	};

	this.completed = async (boxCheckId, createdTimestamp) => {
		window.f7.views.current.router.navigate('/box/check/confirm/' + boxCheckId + '/' + createdTimestamp, {props:{
			onClose:() => {
				this.afterCloseConfirmPage(this.lastScanManual)
			}
			}});
		const keepPopupOpen = true;
		return keepPopupOpen;
	};

	this.afterCloseConfirmPage = async (lastScanManual) => {
		if(!window?.cordova?.InAppBrowser) return;
		const response = await mainAPI.product_feedback.shouldPrompt({lastScanManual});
		if (response?.shouldPrompt) {
			window.popupController.show(AppReviewPopup, {response})
		}
	};

	this._handleScan = async (text, inputManually) => {
		this.lastScanManual = inputManually;
		const timeoutId = setTimeout(() => this.promptForOfflineMode(text, inputManually), 5000);
		let { drug, box, online } = await barcodeAndOfflineLookup(text);
		clearTimeout(timeoutId);
		if (!online) return this.promptForOfflineMode(text, inputManually);
		if (drug && !box) {
			box = models.drug_box.obj(drug.drug_box_id); // use main api
		}
		if (box) {
			this.foundBox(box, drug);
		} else {
			toasts.error('Box not found');
		}
	};

	this.promptForOfflineMode = (scanText) => {
		return window.f7.dialog.confirm(
			'We can save the inventory check when you are back online',
			'Would you like to continue offline?',
			() => {
				scanViewController.hideScanner();
				offlineInventoryCheckController.start(scanText);
				toasts.show('Going offline');
				this.clear();
			}
		);
	};

	this._onDrugScan = async (text, inputManually, type, rawResults) => {
		for (let i in rawResults){
			const isLastResult = ((rawResults.length - 1) === parseInt(i));
			await this._processDrugScan(rawResults[i].text, isLastResult);
		}
	};

	this._processDrugScan = async (text, isLastResult = true) => {
		this.lastScannedCode = {text, ts:Date.now()};
		const lastDrug = this.drugs.find(d=>(d.barcode_id === (text + '')))
		if (lastDrug) {
			this.drugCodesChecked.push(text);
			this.drugCodesChecked = uniq(this.drugCodesChecked);
			this.lastDrugScanned = lastDrug;
			this.myRefs.boxCheckProgressCard.setState({drugCodesChecked:this.drugCodesChecked, lastDrugScanned:this.lastDrugScanned})
		} else {
			toasts.error('Drug not found');
		}
		if (isLastResult) scanViewController.showScanner();
	}

	this.resume = () => {
		console.log('inventoryCheckController.resume');
		scanViewController.hideMainViewDuringAnimation();
		scanViewController.hideScanner((PopupAnimationMs * 2) , 'behind');
		window.popupController.show(BoxScannedPopup, {...this.props, drugCodesChecked: this.drugCodesChecked});
	};

	this.scanForDrugInBox = async (drugs, drugCodesChecked, props, hidePopupsDelayMs, title) => {
		scanViewController.hideMainViewDuringAnimation();
		this.drugs = drugs || [];
		this.drugCodesChecked = drugCodesChecked || [];
		this.props = props;

		scanViewController.showScanner(title, 'Scan a drug in this box', this._onDrugScan, null, false, this.resume,
			{ onDuplicateScan:this.handleDuplicateScan, animateFrom:'behind',hideRootDelayMs:200, forceShowFlashlight:true,forceHideManual:true, bottom: <BoxCheckScanProgressCard drugs={this.drugs} drugCodesChecked={this.drugCodesChecked} onContinue={this.resume} ref={ref=>this.myRefs.boxCheckProgressCard = ref} />});
		if(hidePopupsDelayMs) await setTimeoutAsync(hidePopupsDelayMs)
		window.popupController.hideAll();
	};


};

let inventoryCheckController = new InventoryCheckController();
window.inventoryCheckController = inventoryCheckController;
export default inventoryCheckController;
const setTimeoutAsync = (ms) => {
	return new Promise(resolve => setTimeout(resolve, ms));
};
